import { fetchActiveVisit } from '../../salon-admin/utils/checkinQueueApi';
import { getActiveCheckinSession } from '../../salon/utils/salonFaceSession';

const STORAGE_KEY = 'naturals_reel_checkin_id';

export function persistReelCheckinId(id) {
  if (id == null || String(id).trim() === '') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, String(id));
  } catch {
    /* ignore */
  }
}

export function readStoredReelCheckinId() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function resolveCheckinIdFromUrl(searchParams) {
  const raw =
    searchParams?.get('checkinId') ||
    searchParams?.get('checkin_id') ||
    searchParams?.get('checkin') ||
    '';
  return String(raw || '').trim();
}

/** Resolve today's guest visit for reel capture (URL → memory → storage → API). */
export async function resolveReelCheckinContext(searchParams) {
  const fromUrl = resolveCheckinIdFromUrl(searchParams);
  if (fromUrl) {
    persistReelCheckinId(fromUrl);
  }
  const active = getActiveCheckinSession();
  const checkinId = fromUrl || active?.id || readStoredReelCheckinId();
  if (!checkinId) {
    return { checkinId: '', visit: null };
  }
  const visit = await fetchActiveVisit({ checkinId, includeClosed: true });
  if (visit?.id) {
    persistReelCheckinId(visit.id);
  }
  return {
    checkinId: String(visit?.id || checkinId),
    visit,
  };
}
